import { colors } from "../../Styles";

export function Arrow({rotate = 0, transparency = 1, size = "20px", fillColor = colors.greyLightTertiary, transition = 0}) {
  return (
    <svg style={{transform: `rotate(${rotate}deg)`, transition: `${transition}s ease-in-out`}} opacity={transparency} rotate={rotate} height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">  
      <rect x="1088.45" y="318.08" width="635.36" height="588.26"/>
      <g>
        <path d="M684.31,949.29h91.64c10.19,0,18.53,8.34,18.53,18.53v218.06c0,10.19-8.34,18.53-18.53,18.53h-181.54c-10.19,0-18.53-8.34-18.53-18.53v-218.06c0-10.19,8.34-18.53,18.53-18.53h89.9"/>
        <rect x="596.56" y="970.24" width="176.7" height="211.61"/>
        <line x1="684.91" y1="989.36" x2="754.33" y2="989.36"/>
        <path d="M658.43,984.74h-38.42c-2.2,0-3.98,1.72-3.98,3.85v36.34c0,2.13,1.78,3.85,3.98,3.85h37.2c2.2,0,3.98-1.72,3.98-3.85v-20.99"/>
        <path d="M622.12,1002.39c6.89,3.29,12.97,8.53,16.6,15.35,0,0-5.13.23-5.13.23,1.23-4.07,3.05-7.74,5.38-11.26,6.67-10.22,18.47-18.04,30.95-17.35-10.51,4.54-19.25,11.58-25.65,20.95-3.31,4.56-6.08,10.59-8.3,15.77,0,0-2.3-6.12-2.3-6.12-2.5-6.57-7.06-12.19-11.56-17.56h0Z"/>
        <line x1="684.91" y1="1006.76" x2="754.33" y2="1006.76"/>
        <line x1="684.91" y1="1024.16" x2="754.33" y2="1024.16"/>
        <line x1="611.02" y1="1056.1" x2="754.33" y2="1056.1"/>
        <line x1="611.02" y1="1094.11" x2="706.19" y2="1094.11"/>
        <line x1="611.02" y1="1075.65" x2="726.58" y2="1075.65"/>
        <line x1="611.02" y1="1123.8" x2="695.58" y2="1123.8"/>
        <line x1="611.02" y1="1140.72" x2="685.25" y2="1140.72"/>
        <line x1="611.02" y1="1157.64" x2="686.88" y2="1157.64"/>
        <path d="M710.81,1124.95l96.03-91.86c2.02-1.93,4.73-2.37,6.06-.98l10.49,10.96c1.33,1.39.77,4.08-1.24,6.01l-96.03,91.86-32.19,15.47,16.88-31.47Z"/>
      </g>
      <polygon points="274.9 134.83 158.85 67.82 158.85 106.83 19.79 106.83 19.79 162.83 158.85 162.83 158.85 201.84 274.9 134.83"/>
    </svg>
  );
}
